/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hof_LoadingInputs */



/**
* | output |
* | --- |
* | "Loading Hall of Fame..." |
*
* @param {Hof_LoadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const hof_loading = /** @type {((inputs?: Hof_LoadingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hof_LoadingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement du Hall of Fame...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando Hall of Fame...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Carregando Hall da Fama...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento Hall of Fame...")
	return /** @type {LocalizedString} */ ("Loading Hall of Fame...")
});